import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@shared/api/client';
import { useAuthStore } from '@shared/hooks/useAuthStore';

export type CheckStatus = 'ok' | 'missing' | 'error';
export type CheckGroup = 'identity' | 'infra' | 'access' | 'payments' | 'legal' | 'store' | 'optional';
export interface SetupCheck { id: string; group: CheckGroup; required: boolean; status: CheckStatus; detail?: string }
export interface SetupStatus { enabled: true; tenantSlug: string; checks: SetupCheck[] }

export function useSetupStatus() {
  // Solo il SUPER_ADMIN interroga lo status: su Teramo (FIRSTSETUP spento) i CLUB_ADMIN non generano richieste.
  const isSuper = useAuthStore((s) => s.user?.role === 'SUPER_ADMIN');
  const q = useQuery({
    queryKey: ['admin-setup-status'],
    enabled: isSuper,
    retry: false,
    queryFn: async () => {
      try {
        return (await apiClient.get<SetupStatus>('/admin/setup/status')).data;
      } catch (e) {
        const s = (e as { response?: { status?: number } }).response?.status;
        if (s === 404 || s === 403) return null; // FIRSTSETUP spento
        throw e;
      }
    },
  });
  return { data: q.data ?? undefined, enabled: !!q.data, isLoading: q.isLoading, isError: q.isError, refetch: q.refetch };
}
